import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Security, LoginCallback, SecureRoute } from '@okta/okta-react';

import {
  loginUser,
  setUser,
  logoutUser,
  addAlert,
  removeAlert,
  applicationDoesNotExist
} from '../actions';
import {
  fetchStudent,
  fetchOpenTerm,
  submitApplication,
  fetchApplication
} from '../libs/apiCalls';
import {
  convertToDynamo
} from "../libs/application";
import oktaConfig from '../config/okta';

import Menu from './Menu';
import Notifications from './Notifications';
import Home from './Home';
import Form from './Form';
import Application from './Application';
import Initiate from './Initiate';
import Footer from './Footer';

import '../styles/App.css';
import * as constants from '../config/constants';
import { FETCH_APPLICATION_REQUEST } from "../actions/types";
import { debugLog } from "../libs/app";

class App extends Component {
  constructor(props){
    super(props);
    this.state = {};
    this.handleLogout = this.handleLogout.bind(this);
    this.handleDismissAlert = this.handleDismissAlert.bind(this);
    this.handleSubmitApplication = this.handleSubmitApplication.bind(this);
    this.setUser = this.setUser.bind(this);
    this.fetchApplication = this.fetchApplication.bind(this);
  }

  componentDidMount(){
    debugLog('App componentDidMount');
    //this.props.dispatch(loginUser());

    fetchOpenTerm(this.props.dispatch);

    if(this.props.isLoginComplete) {
      debugLog('Setting user in component mount');
      this.setUser();
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.isLoginComplete && !prevProps.isLoginComplete) {
      debugLog('Setting user in component update');
      await this.setUser();
    }
    if (
      this.props.userSet &&
      this.props.openTermSet &&
      !(prevProps.userSet && prevProps.openTermSet) &&
      this.props.invokingType !== FETCH_APPLICATION_REQUEST // Stops it from double firing
    ) {
      await this.fetchApplication();
    }
  }

  handleLogout() {
    this.props.dispatch(logoutUser());
  }

  handleDismissAlert(id) {
    this.props.dispatch(removeAlert(id))
  }

  handleSubmitApplication() {
    const newApplication = convertToDynamo(this.props.application);
    debugLog('Submitting Application: ', newApplication);
    submitApplication(this.props.dispatch, newApplication);
    window.scrollTo(0, 0);
  }

  async fetchApplication() {
    debugLog('user set, fetching application');
    const fetchResult = await fetchApplication(this.props.dispatch,
                                                this.props.user.deltaId,
                                                this.props.openTerm.name);
    if(!fetchResult.status)
      if(fetchResult.reason === constants.REASON_NOT_FOUND)
        this.props.dispatch(applicationDoesNotExist());
      else
        this.props.dispatch(addAlert('danger', fetchResult.reason));
  }

  async setUser() {
    debugLog('Fetching user');
    const fetchResult = await fetchStudent(this.props.dispatch);
    const user = fetchResult.user;
    let createInterval = false;
    let destroyInterval = false;
    // Status true means student is found and complete or updating
    if(fetchResult.status) {
      this.props.dispatch(setUser(user));
      // If the student is updating, we still need to refresh
      if(!user.complete) {
        debugLog('User found but not complete. Recheck in 5 seconds');
        createInterval = true;
      } else {
        debugLog('no need for interval');
        destroyInterval = true;
      }
    } else {
      // If it's not an error, it's a new student
      if(fetchResult.error) {
        this.props.dispatch(addAlert('danger', fetchResult.reason));
      } else {
        // Set the empty user anyway to trigger new user mode
        this.props.dispatch(setUser(user));
        createInterval = true;
      }
    }
    if(createInterval && !this.state.intervalId){
      let intervalId = setInterval(this.setUser, constants.RECHECK_INTERVAL);
      this.setState({intervalId});
    }
    if(destroyInterval && this.state.intervalId) {
      debugLog('Stopping rechecks ', destroyInterval);
      clearInterval(this.state.intervalId);
    }
    return user;
  }

  render() {
    const {
      statusMessage,
      errorMessage,
      error,
      isFetchingCredentials,
      isAuthenticating,
      isInvoking,
      invokingMessage,
      alerts,
      newUser,
      updatingUser,
      application,
      applicationSet
    } = this.props;

    const { oktaClientConfig } = oktaConfig;

    return (
      <Router>
        <Security issuer={oktaClientConfig.issuer}
                  clientId={oktaClientConfig.clientId}
                  redirectUri={oktaClientConfig.redirectUri}>
          <div className="main-container">
            <Menu />
            <Grid>
              <Notifications
                isAuthenticating={isAuthenticating}
                isFetchingCredentials={isFetchingCredentials}
                error={error}
                errorMessage={errorMessage}
                statusMessage={statusMessage}
                isInvoking={isInvoking}
                invokingMessage={invokingMessage}
                alerts={alerts}
                onDismissAlert={this.handleDismissAlert}
                newUser={newUser}
                updatingUser={updatingUser}
              />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/home" component={Home} />
                <SecureRoute path="/form" render={(props) => (
                  <Form {...props} onSubmit={this.handleSubmitApplication} />
                )} />
                <SecureRoute path="/application" render={(props) => (
                  <Application {...props} application={application} applicationSet={applicationSet} />
                )} />
                <Route path="/login" component={LoginCallback} />
                <Route path="/initiate" component={Initiate} />
              </Switch>
            </Grid>
            <Footer />
          </div>
        </Security>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { auth, appInfo, application } = state;
  const {
    isAuthenticating,
    isAuthenticated,
    errorMessage,
    error,
    isCredentialsSet,
    isLoginComplete,
    isFetchingCredentials,
    statusMessage,
    user,
    userSet
  } = auth;
  const {
    openTermSet,
    openTerm,
    invokingMessage,
    isInvoking,
    invokingType,
    alerts,
    newUser,
    updatingUser,
    optionsSet,
    applicationSet
  } = appInfo;
  return {
    isAuthenticating,
    isAuthenticated,
    statusMessage,
    errorMessage,
    error,
    isFetchingCredentials,
    isCredentialsSet,
    isLoginComplete,
    user,
    userSet,
    openTermSet,
    openTerm,
    invokingMessage,
    invokingType,
    isInvoking,
    alerts,
    newUser,
    updatingUser,
    application,
    optionsSet,
    applicationSet
  }
}

export default connect(mapStateToProps)(App);